module.exports = __webpack_public_path__ + "img/locusta-migratoria.337ed923.jpg";